$(function() {
    const swiper = new Swiper('.home-blog-swiper', {
        speed: 400,
        slidesPerView: 2,
        spaceBetween: 30,
        breakpoints : {
            600: {
                slidesPerView: 3
            }
        },
         breakpoints : {
            900: {
                slidesPerView: 4
            }
        }
    });

    const productSwiper = new Swiper('.home-product-swiper', {
    speed: 400,
        slidesPerView: 2,
        spaceBetween: 30,
        breakpoints : {
            600: {
                slidesPerView: 3
            }
        },
         breakpoints : {
            900: {
                slidesPerView: 4
            }
        }
    });

    $('.list-faq dt').click(function() {
        $(this).toggleClass('open');
        $(this).next('dd').slideToggle();
    });
    $('.btn-hamburger').click(function() {
        $(this).toggleClass('open');
        const is_open = $(this).hasClass('open');

        $('.header').toggleClass('open', is_open);
    });

    function setMainVisualHeight() {
        const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        const main = document.querySelector('.mainvisual');
        if (main) {
            main.style.height = vh + 'px';
        }
    }

    setMainVisualHeight();
    window.addEventListener('resize', setMainVisualHeight);
    window.addEventListener('orientationchange', setMainVisualHeight);
});